module.exports = __webpack_public_path__ + "img/forum.99dd9419.jpg";